/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropbox_Announcement_TitleInputs */

const en_dropbox_announcement_title = /** @type {(inputs: Dropbox_Announcement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropbox is here`)
};

const es_dropbox_announcement_title = /** @type {(inputs: Dropbox_Announcement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropbox ya está aquí`)
};

/**
* | output |
* | --- |
* | "Dropbox is here" |
*
* @param {Dropbox_Announcement_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_announcement_title = /** @type {((inputs?: Dropbox_Announcement_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_Announcement_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_announcement_title(inputs)
	return en_dropbox_announcement_title(inputs)
});